import { useEffect, useState } from "react";
import { Layout, ConfigProvider } from "antd";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "../hooks/reduxHooks";
import { getTenantSetupCheckApi } from "../services/tenantSetup.service";
import { getAuthCookieValue } from "../utils/authCookie";
import { getLoginPathForTenantContext } from "../utils/tenantFromHost";

const TenantSetupLayout = (props) => {
  const { children } = props;
  const dispatch = useAppDispatch();

  const token = getAuthCookieValue("authToken");
  const isAuthenticated = !!token;
  const [isLoading, setIsLoading] = useState(true);
  const [tenantSetupCompleted, setTenantSetupCompleted] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsLoading(false);
      return;
    }

    const resolveSetupComplete = (response) => {
      if (typeof response === "boolean") return response;
      if (response && typeof response === "object") {
        if (typeof response.setup_complete === "boolean") return response.setup_complete;
        if (typeof response.is_setup_complete === "boolean") return response.is_setup_complete;
        if (typeof response.tenant_setup_completed === "boolean") return response.tenant_setup_completed;
        if (typeof response.completed === "boolean") return response.completed;
        if (response.status === "success") return true;
      }
      return false;
    };

    dispatch(
      getTenantSetupCheckApi({
        finalCallback: () => {
          setIsLoading(false);
        },
        successCallback: (response) => {
          const isSetupComplete = resolveSetupComplete(response);
          setTenantSetupCompleted(isSetupComplete);
          localStorage.setItem("tenantSetupCompleted", isSetupComplete ? "true" : "false");
          if (response && typeof response.tutorial_complete !== "undefined") {
            localStorage.setItem("tutorialComplete", response.tutorial_complete.toString());
          }
        },
        failureCallback: () => {
          setTenantSetupCompleted(false);
          localStorage.setItem("tenantSetupCompleted", "false");
        },
      })
    );
  }, [dispatch, isAuthenticated]);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    const slug = getAuthCookieValue("slug") || "";
    return <Navigate to={getLoginPathForTenantContext({ slug })} replace />;
  }

  if (isLoading) {
    return null;
  }

  // If tenant setup is already completed, redirect to dashboard
  if (tenantSetupCompleted) {
    return <Navigate to="/" replace />;
  }

  return (
    <ConfigProvider>
      <Layout 
        className="tenant-setup-layout" 
        style={{ 
          minHeight: "100vh",
          background: "transparent"
        }}
      >
        {children}
      </Layout>
    </ConfigProvider>
  );
};

export default TenantSetupLayout;
